export default "__VITE_ASSET__CTY8Ae5e__"